import {Component, Injector, ViewChild} from '@angular/core';
import {DialogBaseComponent} from "../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { RaceViewModel} from "../Model/RaceViewModel";
import { RacesService } from "../../../services/races.service";
import { ConverterService } from "../../../services/converter.service";
import { ImageUploadComponent } from "../../shared/components/image-upload/image-upload.component";

@Component({
    selector: '[app-race-dialog-base]',
    templateUrl: './race-dialog-base.component.html',
    styleUrls: ['./race-dialog-base.component.css'],
    standalone: false
})
export class RaceDialogBaseComponent extends DialogBaseComponent<RaceViewModel> {
  private racesService: RacesService;
  private converterService: ConverterService;

  @ViewChild("image") imageupload: ImageUploadComponent;

  constructor(protected injector: Injector)
  {
    super(injector);
    this.racesService = injector.get(RacesService);
    this.converterService = injector.get(ConverterService);
    this.dialogId = "editActivity";
  }

  public submit()
  {
    this.model.Image = this.imageupload.files.length ? this.imageupload.files[0].src : null;
    this.racesService.update(this.model)
      .subscribe((res) =>
      {
        this.onCreated.emit();
        this.close();
        this.syncService.NotifyEntityChanged("Activity", this.model.Id);
        super.submit();

      });
  }
  public convertDistance(value: number)
  {
    this.model.Distance = this.converterService.ParseKMeters(value);
  }
}
